import React from 'react';
import { Box, Flex, Skeleton } from '@skin-seoul/design-system';

export const LoyaltyBannerSkeletonDesktop = () => {
  return (
    <Box position="relative" width="100%" height="112px" borderRadius="8px" bg="neutral.100" overflow="hidden">
      <Flex
        position="relative"
        height="100%"
        alignItems="center"
        justifyContent="space-between"
        pl={4}
        pr={6}
        py={4}
        zIndex={1}
      >
        {/* Left Side - Title and Subtitle Skeleton */}
        <Flex direction="column" gap={2}>
          <Flex direction="column" gap={1}>
            <Skeleton height="20px" width="120px" />
            <Skeleton height="20px" width="100px" />
          </Flex>
          <Skeleton height="14px" width="150px" />
        </Flex>

        {/* Right Side - Points Skeleton */}
        <Flex direction="column" gap={1} alignItems="flex-end">
          <Skeleton height="14px" width="80px" />
          <Skeleton height="24px" width="100px" />
        </Flex>
      </Flex>
    </Box>
  );
};
